"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ButtonsWrap = exports.ContainerStyled = exports.HeroSlideBlock = exports.Content = exports.Wrap = void 0;

var _uiKit = require("@dbi-tools/ui-kit");

var _heroSlide = require("../../hero-slide.styled");

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  ", " {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    min-height: 119px;\n  }\n\n  ", " {\n    margin-top: 30px;\n  }\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  ", " {\n    max-width: 100%;\n  }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  background-color: ", ";\n  padding: 30px;\n\n  ", " {\n    display: flex;\n    width: 100%;\n    min-height: 264px;\n\n    & > div {\n      flex-grow: 1;\n    }\n  }\n\n  ", " {\n    flex-direction: column;\n    justify-content: center;\n    padding: 29px 24px;\n    height: 400px;\n    overflow: hidden;\n  }\n\n  ", " {\n    word-break: break-word;\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral([""]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  top: 100%;\n  transform: translateY(-100%);\n\n  ", " {\n    display: flex;\n    align-items: flex-end;\n    min-height: ", ";\n  }\n\n  ", " {\n    padding-top: 50px;\n    &::before {\n      content: '';\n      position: absolute;\n      top: -70%;\n      left: 0;\n      right: 0;\n      height: 90%;\n      ", ";\n      z-index: -1;\n    }\n  }\n\n  ", " {\n    &::before {\n      top: -210px;\n      height: 280px;\n    }\n  }\n\n  ", " {\n    &::before {\n      top: -50%;\n      height: 66.66%;\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Wrap = (0, _uiKit.styled)('div')(_templateObject(), _uiKit.GridBreakpointsMediaUp.md, function (_ref) {
  var height = _ref.theme.height;
  return height ? "".concat(height, "px") : 'auto';
}, _uiKit.GridBreakpointsMediaDown.lg, function (_ref2) {
  var bgStyles = _ref2.bgStyles;
  return bgStyles;
}, _uiKit.GridBreakpointsMediaDown.md, _uiKit.GridBreakpointsMediaDown.sm);
exports.Wrap = Wrap;
var Content = (0, _uiKit.styled)('div')(_templateObject2());
exports.Content = Content;
var HeroSlideBlock = (0, _uiKit.styled)('div')(_templateObject3(), function (_ref3) {
  var bg = _ref3.bg;
  return bg ? _uiKit.Colors[bg] : _uiKit.Colors['transparent'];
}, _uiKit.GridBreakpointsMediaDown.lg, _uiKit.GridBreakpointsMediaDown.sm, _heroSlide.Line2);
exports.HeroSlideBlock = HeroSlideBlock;
var ContainerStyled = (0, _uiKit.styled)(_uiKit.Container)(_templateObject4(), _uiKit.GridBreakpointsMediaDown.lg);
exports.ContainerStyled = ContainerStyled;
var ButtonsWrap = (0, _uiKit.styled)('div')(_templateObject5(), _uiKit.GridBreakpointsMediaUp.md, _uiKit.GridBreakpointsMediaDown.md);
exports.ButtonsWrap = ButtonsWrap;